import React from 'react'
import "../../Styles/signin.css";
import { Link } from 'react-router-dom';
import { IMAGES } from '../../utils/images';


const LoginWithOptions = ({call}) => {
    
  return (
    <div className="signin-left-container">
          <h1 className="signin-heading">Welcome Back</h1>
          <h2 className="signin-title">Login</h2>
         <button className="email-button" onClick={()=>call(1)}>
            Continue with email
          </button>
          <div className="other-login-div">
            <hr />
            <p>Other login options</p>
            <hr />
          </div>
          <button className="continue-with"> <img src={IMAGES.GOOGLE_ICON}/> Continue with Gmail</button>
          <button className="continue-with"><img src={IMAGES.FACEBOOK_ICON_LOGIN}/>Continue with Facebook</button>
          <button className="continue-with"><img src={IMAGES.APPLE_ICON}/>Continue with Apple</button>
          <h2 className="signin-btn">
            Don’t have an account?
            <Link to="/signup" className="link">
              <button> Sign Up</button>
            </Link>
          </h2>

        </div>
  )
}

export default LoginWithOptions